import { SearchOutlined } from '@ant-design/icons';
import { Input, Space, Button } from 'antd';
import Highlighter from 'react-highlight-words';

type GetTableScroll = {
  extraHeight?: number;
  id?: string;
};

/**
 *  Get the visualization height of the first table
 * @param {*} extraHeight  Extra height ( The content height at the bottom of the table  Number type , The default is 74)
 * @param {*} id  There are multiple... In the current page table We need to make table Of id
 */
export function getTableScroll({ extraHeight, id }: GetTableScroll = {}) {
  if (typeof extraHeight == 'undefined') {
    //   Default bottom pagination 64 +  Margin 10
    // extraHeight = 24 + 70 + 60;
    extraHeight = 150;
  }
  let tHeader = null;
  if (id) {
    tHeader = document.getElementById(id)
      ? document.getElementById(id).getElementsByClassName('ant-table-thead')[0]
      : null;
  } else {
    tHeader = document.getElementsByClassName('ant-table-thead')[0];
  }
  // The distance from the table content to the top
  let tHeaderBottom = 0;
  if (tHeader) {
    tHeaderBottom = tHeader.getBoundingClientRect().bottom;
  }
  // Form height - The height of the top of the table content - The height of the bottom of the table content
  // let height = document.body.clientHeight - tHeaderBottom - extraHeight
  let height = `calc(100vh - ${tHeaderBottom + extraHeight}px)`;
  return height;
}
